module.exports = __webpack_public_path__ + "img/icon-3-green.b19d4e97.svg";